export default "__VITE_ASSET__CB_0BMjA__"